import { jsx as _jsx } from "react/jsx-runtime";
import { Helmet } from '../';
const PageTitle = ({ title }) => (_jsx(Helmet, { children: _jsx("title", { children: title }) }));
export default PageTitle;
